import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './service-information.component';
import { LineasComponent } from './lineas/lineas.component';
import { ParadasComponent } from './paradas/paradas.component';
import { MapaComponent } from './mapa/mapa.component';
import { MapaContainerComponent } from './mapaContainer/mapaContainer.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { HorariosComponent } from './horarios/horarios.component';

@NgModule({
  declarations: [
    AppComponent,
    LineasComponent,
    ParadasComponent,
    MapaComponent,
    TarifasComponent,
    HorariosComponent,
    MapaContainerComponent
  ],
  imports: [ BrowserModule, FormsModule, HttpClientModule ],
  providers: [],
  bootstrap: [ AppComponent ],
  entryComponents: [
    LineasComponent,
    ParadasComponent,
    MapaComponent,
    TarifasComponent,
    HorariosComponent,
    MapaContainerComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/service-information.module.ts